<template>
  <form class="form form--contact" method="post" @submit.prevent="submitForm($event)" id="formIRContact" autocomplete="off">

    <Modal v-model="showModal" :title="formTitle" :status="formSuccess" :message="formMessage" @close="resetModal" template="irContact" />

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="form-label" for="fullname">{{ translate("fullname") }}*</label>
          <input class="form-control" type="text" id="fullname" name="fullname" maxlength="300" value="" required>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <label class="form-label" for="address">{{ translate("address") }}*</label>
          <input class="form-control" type="text" id="address" name="address" maxlength="2000" value="" required>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <label class="form-label" for="country">{{ translate("country") }}*</label>
          <input class="form-control" type="text" id="country" name="country" maxlength="2000" value="" required>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <label class="form-label" for="email">{{ translate("email") }}*</label>
          <input class="form-control" type="email" id="email" name="email" maxlength="50" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" value="" required>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <label class="form-label" for="phone">{{ translate("phone") }}*</label>
          <input class="form-control" type="tel" id="phone" name="phone" maxlength="20" value="" required>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <label class="form-label" for="fax">{{ translate("fax") }}*</label>
          <input class="form-control" type="tel" id="fax" name="fax" maxlength="20" value="" required>
        </div>
      </div>


      <div class="col-12">
        <div class="form-group">
          <label for="subject" class="form-label">{{ translate("subject") }}*</label>
          <input type="text" class="form-control" name="subject" id="subject" maxlength="1000" value="" required/>
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          <label for="comment" class="form-label">{{ translate("comment.suggestion") }}*</label>
          <textarea rows="1" class="form-control" name="comment" id="comment" maxlength="10000" required></textarea>
        </div>
      </div>

      
      <div class="col-12">
        <div class="form__block mt-2">
            <div class="custom-control custom-checkbox">
                <input 
                type="checkbox" 
                class="custom-control-input" 
                name="privacyStatement"
                v-model="isChecked"
                @change="handleCheckboxChange"
                >
                <label class="custom-control-label" v-html="translate('privacy.statement.text')"></label>
            </div>
  
            <div class="form__btn">
                <button 
                    type="submit" 
                    class="btn btn--secondary" 
                    :disabled="!isChecked"
                    >
                    <span class="btn__title">{{ translate("submit") }}</span>
                </button>
            </div>
        </div>
      </div>

      
    </div>
  </form>
</template>

<script setup>

const isChecked = ref(false)


const props = defineProps({
  posts: {
    type: Object,
    required: true,
  },
});

import { useFormIrContact } from "@/composables/useFormIrContact";

import Modal from "@/components/helpers/Modal.vue";
import Loading from "@/components/helpers/Loading.vue";

// ใช้ Composable
const {
  isLoading,
  LoadingTitle,
  formSuccess,
  formTitle,
  formMessage,
  showModal,
  privacyStatement,
  submitForm,
  resetModal,
  translate,
} = useFormIrContact();


</script>

<style lang="scss" scoped></style>
